export default __webpack_public_path__ + "static/media/clearVk.0c6184d7.svg";